import React from 'react';
import styled from 'styled-components';

const Container = styled.section`
  padding: 5rem 5%;
  background-color: ${({ theme }) => theme.colors.surface};
  text-align: center;
  scroll-margin-top: 100px;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: 3rem;
  
  span {
    position: relative;
    z-index: 1;
    &::after {
      content: '';
      position: absolute;
      bottom: 5px;
      left: 0;
      width: 100%;
      height: 10px;
      background-color: ${({ theme }) => theme.colors.accentTeal}60;
      z-index: -1;
    }
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Card = styled.div`
  background: ${({ theme }) => theme.colors.background};
  padding: 2rem;
  border-radius: 16px;
  text-align: left;
  transition: transform 0.3s ease;
  border: 1px solid transparent;

  &:hover {
    transform: translateY(-5px);
    border-color: ${({ theme }) => theme.colors.accentOrange};
  }
`;

const Icon = styled.div`
  font-size: 2rem;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.primary};
`;

const CardTitle = styled.h3`
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.secondary};
`;

const CardText = styled.p`
  color: ${({ theme }) => theme.colors.light};
  line-height: 1.5;
`;

const FeaturesSection = () => {
  return (
    <Container id="diferenciais">
      <SectionTitle>Por que usar a <span>es.cu.ta</span>?</SectionTitle>
      <Grid>
        <Card>
          <Icon>💬</Icon>
          <CardTitle>Especialista em PT-BR</CardTitle>
          <CardText>
            Chega de ferramentas gringas que não entendem ironia e gírias locais. Nossa IA é especializada no português brasileiro e seus dialetos.
          </CardText>
        </Card>
        <Card>
          <Icon>🎯</Icon>
          <CardTitle>Foco no Instagram</CardTitle>
          <CardText>
            Você não precisa pagar por módulos de outras redes se o seu foco é o engajamento visual e comentários do Instagram.
          </CardText>
        </Card>
        <Card>
          <Icon>📉</Icon>
          <CardTitle>Preço Acessível</CardTitle>
          <CardText>
            Tecnologia de ponta com um custo que cabe no orçamento de agências locais e pequenas empresas.
          </CardText>
        </Card>
      </Grid>
    </Container>
  );
};

export default FeaturesSection;